module.exports = __webpack_public_path__ + "img/phone-outgoing.55cac47b.svg";